module.exports = __webpack_public_path__ + "img/download-cloud.2f51d20c.svg";